import { render, staticRenderFns } from "./addadmintrans.vue?vue&type=template&id=248cb9f0&"
import script from "./addadmintrans.vue?vue&type=script&lang=js&"
export * from "./addadmintrans.vue?vue&type=script&lang=js&"
import style0 from "./addadmintrans.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports